require('./RAFooter.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
const PrinterPreviewManagerButton = require('components/contactCenter/printer/printerPreviewManagerButton');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { GO_BACK_URL } = require('../../../raConstants/index');

class RAFooter extends React.Component {
    constructor() {
        super();
        this.handleCancelClick = this.handleCancelClick.bind(this);
    }

    handleCancelClick() {
        const { cancelPath, onLeftButtonClick, history } = this.props;
        onLeftButtonClick();
        if (cancelPath === GO_BACK_URL) {
            history.goBack();
        } else {
            history.push(cancelPath);
        }
    }

    buildRightContent() {
        const {
            disableRightButton,
            includePrintPreviewManagerButton,
            onRightButtonClick,
            rightButtonText,
            tooltipText,
            loading,
        } = this.props;
        let tooltipContent, rightButtonBlock;

        if (tooltipText) {
            tooltipContent = (
                <div className="ra-footer__tooltip-container">
                    <i className="ra-footer__icon icon icon-informacion" />
                    <span className="ra-footer__tooltip">{tooltipText}</span>
                </div>
            );
        }

        const rightButton = (
            <OKButton
                disabled={disableRightButton}
                modifier="primary"
                onClick={onRightButtonClick}
                loading={loading}
            >
                {rightButtonText}
            </OKButton>
        );
        if (includePrintPreviewManagerButton) {
            rightButtonBlock = (
                <React.Fragment>
                    <ContactCenterRender>
                        <PrinterPreviewManagerButton
                            disabled={disableRightButton}
                            modifier="primary"
                            onClick={onRightButtonClick}
                            loading={loading}
                        >
                            {rightButtonText}
                        </PrinterPreviewManagerButton>
                    </ContactCenterRender>
                    <WebappRender>{rightButton}</WebappRender>
                </React.Fragment>
            );
        } else {
            rightButtonBlock = rightButton;
        }

        return (
            <div>
                {tooltipContent}
                {rightButtonBlock}
            </div>
        );
    }

    render() {
        const { showRightContent } = this.props;
        const rightContentBlock = showRightContent
            ? this.buildRightContent()
            : null;

        return (
            <div className="ra-footer">
                <div className="ra-footer__content">
                    <div className="content-left">
                        <OKButton
                            modifier="link-ghost"
                            onClick={this.handleCancelClick}
                        >
                            <FormattedText value="raSuitabilityTest-cancel" />
                        </OKButton>
                    </div>
                    <div className="content-right">{rightContentBlock}</div>
                </div>
            </div>
        );
    }
}

RAFooter.propTypes = {
    history: PropTypes.object.isRequired,
    cancelPath: PropTypes.string.isRequired,
    disableRightButton: PropTypes.bool,
    includePrintPreviewManagerButton: PropTypes.bool,
    loading: PropTypes.bool,
    onLeftButtonClick: PropTypes.func,
    onRightButtonClick: PropTypes.func,
    rightButtonText: PropTypes.string,
    showRightContent: PropTypes.bool,
    tooltipText: PropTypes.string,
};

RAFooter.defaultProps = {
    disableRightButton: false,
    includePrintPreviewManagerButton: false,
    loading: false,
    onLeftButtonClick: () => {},
    showRightContent: false,
};

module.exports = withRouter(RAFooter);
